import React from 'react';
import { FiTarget, FiUsers, FiShield, FiAward } from 'react-icons/fi';

const About: React.FC = () => {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'AboutPage',
            mainEntity: {
              '@type': 'Organization',
              name: "Let's Try Bet",
              description:
                'Guide expert des paris sportifs en France. Comparaison des meilleurs bookmakers.',
            },
          }),
        }}
      />

      <div className="min-h-screen pt-20">
        <section className="py-20">
          <div className="container mx-auto px-4">
            <h1 className="text-5xl font-bold text-white text-center mb-4">
              À Propos de Let's Try Bet
            </h1>
            <p className="text-center text-dark-muted text-xl mb-12 max-w-3xl mx-auto">
              Votre partenaire de confiance pour naviguer dans l'univers des paris sportifs en
              France.
            </p>

            <div className="max-w-4xl mx-auto space-y-8">
              <div className="bg-dark-card border border-dark-border rounded-lg p-8">
                <h2 className="text-3xl font-bold text-white mb-4">Notre Mission</h2>
                <p className="text-dark-muted leading-relaxed">
                  Chez Let's Try Bet, nous nous engageons à fournir des informations précises,
                  transparentes et à jour sur les meilleurs bookmakers français. Notre objectif est
                  de vous aider à faire des choix éclairés en comparant les offres, les bonus et
                  les conditions de chaque plateforme.
                </p>
              </div>

              <div className="bg-dark-card border border-dark-border rounded-lg p-8">
                <h2 className="text-3xl font-bold text-white mb-4">Notre Expertise</h2>
                <p className="text-dark-muted leading-relaxed mb-4">
                  Notre équipe est composée d'experts en paris sportifs qui testent régulièrement
                  les différentes plateformes. Nous évaluons :
                </p>
                <ul className="list-disc list-inside text-dark-muted space-y-2">
                  <li>La qualité des cotes et des marchés disponibles</li>
                  <li>La rapidité des paiements et des retraits</li>
                  <li>L'expérience utilisateur et l'interface</li>
                  <li>Le service client et le support</li>
                  <li>Les bonus et promotions</li>
                  <li>La sécurité et la licence ANJ</li>
                </ul>
              </div>

              <div className="grid md:grid-cols-2 gap-6">
                {[
                  {
                    icon: FiTarget,
                    title: 'Objectivité',
                    description:
                      'Nos avis sont indépendants et basés sur des tests réels de chaque plateforme.',
                  },
                  {
                    icon: FiUsers,
                    title: 'Transparence',
                    description:
                      'Nous communiquons clairement sur les avantages et inconvénients de chaque offre.',
                  },
                  {
                    icon: FiShield,
                    title: 'Sécurité',
                    description:
                      'Nous ne recommandons que des bookmakers licenciés et régulés par l\'ANJ.',
                  },
                  {
                    icon: FiAward,
                    title: 'Excellence',
                    description:
                      'Nous nous efforçons de maintenir les plus hauts standards de qualité dans nos analyses.',
                  },
                ].map((value, i) => (
                  <div
                    key={i}
                    className="bg-dark-card border border-dark-border rounded-lg p-6 hover:border-accent-primary transition-all"
                  >
                    <value.icon className="text-accent-primary mb-4" size={32} />
                    <h3 className="text-xl font-bold text-white mb-2">{value.title}</h3>
                    <p className="text-dark-muted">{value.description}</p>
                  </div>
                ))}
              </div>

              <div className="bg-dark-card border border-dark-border rounded-lg p-8">
                <h2 className="text-3xl font-bold text-white mb-4">Notre Engagement</h2>
                <p className="text-dark-muted leading-relaxed">
                  Nous croyons fermement au jeu responsable. Tous les bookmakers que nous
                  recommandons sont licenciés en France et respectent les réglementations en
                  vigueur. Nous encourageons toujours nos lecteurs à jouer de manière responsable
                  et à ne jamais parier plus qu'ils ne peuvent se permettre de perdre.
                </p>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default About;

